import classnames from 'classnames';
import { Container } from '@stadionhq-v3/base-ui';
import { SfaShirtCtaBarProps } from './sfaShirtCtaBar.types';
import styles from './sfaShirtCtaBar.module.scss';

const SfaShirtCtaBar = ({
  nativeProps = {},
  classNames = [],
  testId = 'sfa-shirt-cta-bar',
  thumbnail,
  label,
  ctaText,
  ctaUrl,
  ctaIcon,
}: SfaShirtCtaBarProps) => (
  <div
    {...nativeProps}
    data-testid={testId}
    className={classnames(styles.sfaShirtCtaBar, classNames)}
  >
    <Container classNames={[classnames(styles.inner)]}>
      <div className={styles.left}>
        <span className={styles.thumbnail} aria-hidden="true">
          {thumbnail}
        </span>
        <span className={styles.label}>{label}</span>
      </div>
      <a
        className={styles.cta}
        href={ctaUrl}
        aria-label={`${ctaText}: ${label}`}
      >
        <span>{ctaText}</span>
        {ctaIcon ? (
          <span className={styles.ctaIcon} aria-hidden="true">
            {ctaIcon}
          </span>
        ) : null}
      </a>
    </Container>
  </div>
);

export default SfaShirtCtaBar;
